import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { environment } from '../../environments/environment';

declare const initDataRange: any

@Injectable({ providedIn: 'root' })
export class CalendarService {
    public CalendarRangeDate = new Subject();
    
    constructor(){
    }

    getCalendarRange(){
        return this.CalendarRangeDate;
    }

    setCalendarRange(range: any) {
        this.CalendarRangeDate.next(range);
    }

    formatDate(date: any, isoString=false) {
      if (isoString){
        return date.toISOString();
      }else{
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
      }
    }

    callDataRange(field: string, 
      empresaId: string, 
      applyFilterDataRange: Function, 
      self: any) {

        var dateOld = '';
        if(field) {
          field = 'creation_date'
        }
        
        self.solrService.getDateOld(environment.solr.url, 'docs-ia', field, empresaId).subscribe((data: any) => {
          if(data.response.docs.length == 1) {
            dateOld = data.response.docs[0][field].split('T')[0]
          }
          initDataRange(applyFilterDataRange, self, self.solrService, 'calendario', dateOld);
        });
    
        // initDataRange(this.applyFilterDataRange, this, "relatorio");
      }
}